export class FilterModelBase {
  selectedFields: string[];
  defaultFields: string[];
}
